import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessFollowUpSiteVisitViewModel, IBusinessSiteVisitViewModel } from "app/models/complaints/siteVisit";
import { IAdministrativeComplaintView } from "app/models/mainMenu/mainMenu";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { SiteVisitService } from "app/services/complaint/siteVisit.service";

@Component({
  selector: 'shared-followupVisitEdit',
  styleUrls: ['./followupVisitEdit.component.scss'],
  templateUrl: './followupVisitEdit.component.html'
})

export class FollowupVisitEditComponent implements OnInit {

  businessId: number = 0;
  saved: boolean = false;
  showSave: boolean = false;
  reviewed: boolean = false;
  followupInspection: boolean = false;
  siteVisitConducted: boolean = false;
  complaintDueDate: Date = null;

  warningFlag: boolean = false;
  followupFlag: boolean = false;
  localComplaint: IAdministrativeComplaintView = {} as IAdministrativeComplaintView;

  siteVisitItems: IBusinessSiteVisitViewModel = {} as IBusinessSiteVisitViewModel;
  siteVisit: IBusinessFollowUpSiteVisitViewModel = {} as IBusinessFollowUpSiteVisitViewModel;

  form = new UntypedFormGroup({
    followupDate: new UntypedFormControl(Date, [Validators.required]),
    followupConducted: new UntypedFormControl('', [Validators.required]),
    remediationResult: new UntypedFormControl(''),
    comments: new UntypedFormControl('')
  });

  constructor(
    private sharedService: SharedService,
    private siteVisitService: SiteVisitService,
    private complaintService: ComplaintService,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<FollowupVisitEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.siteVisit = this.data.siteVisit;
    this.siteVisitItems = this.siteVisitService.siteVisit;
    this.localComplaint = this.complaintService.currentComplaint;
    if (this.siteVisit != null && this.siteVisit != undefined && this.siteVisit.id != 0) {
      this.setFormData(this.siteVisit);
      this.showSave = true;
    }
    this.businessId = this.localComplaint.businessId;
  }

  ngOnInit(): void {
    this.saved = false;
  }

  save() {
    if (!this.form.valid) {
      this.sharedService.toastr.error("Please fill in all required fields");
      return;
    }
    else {
      this.setSaveData();

      this.siteVisitService.saveSiteVisits(this.businessId, this.siteVisitItems).subscribe({
        next: response => {
          this.sharedService.toastr.success("Saved");
          this.saved = true;
          this.return();
        },
        error: e => {
          this.sharedService.toastr.error("Could not save Site Visit data.");
        },
      });
    }
  }


  siteVisitUpdate(visited: string) {
    this.followupFlag = visited == '1' ? true : false;
  }

  setSaveData() {
    if (this.form.valid) {
      let data = this.form.value;
    
      let visit = this.siteVisitItems.followupSiteVisits.findIndex(x => x.id == this.siteVisit.id);
      if (visit != null) {
        this.siteVisitItems.followupSiteVisits[visit].followupDate = this.datePipe.transform(data.followupDate, 'MM/dd/yyyy');
        this.siteVisitItems.followupSiteVisits[visit].followupConducted = +data.followupConducted;
        this.siteVisitItems.followupSiteVisits[visit].remediationResult = data.remediationResult.toString();
        this.siteVisitItems.followupSiteVisits[visit].comments = data.comments;
        this.siteVisitItems.followupSiteVisits[visit].allowEditing = true;
      }
    }
  }

  setFormData(data: IBusinessFollowUpSiteVisitViewModel) {
    this.form.patchValue({
      followupDate: this.siteVisit.followupDate != null ? new Date(this.siteVisit.followupDate) : '',
      followupConducted: this.siteVisit.followupConducted != null ? this.siteVisit.followupConducted.toString() : '',
      remediationResult: this.siteVisit.remediationResult,
      comments: this.siteVisit.comments
    });
    this.radioSelected(this.siteVisit.remediationResult);
  }

  radioSelected(value: string) {
    if (this.followupFlag) {
       this.warningFlag = +value > 1;
    }
    else{
      this.warningFlag = false;
    }

  }
  
  return(): void {
    let returnData = this.saved ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }
}
